import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('[ErrorBoundary]', error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="container-fluid py-5">
          <div className="row justify-content-center">
            <div className="col-md-8 col-lg-6">
              <div className="card border-0 shadow-sm">
                <div className="card-body text-center py-5">
                  <i className="bi bi-exclamation-triangle-fill text-warning" style={{ fontSize: '3rem' }}></i>
                  <h4 className="mt-3 fw-bold">Something went wrong</h4>
                  <p className="text-muted mb-4">
                    An unexpected error occurred. Please refresh the page or navigate back to the dashboard.
                  </p>
                  <div className="d-flex gap-2 justify-content-center">
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        this.setState({ hasError: false, error: null });
                        window.location.href = '/trust-tech-studio';
                      }}
                    >
                      <i className="bi bi-house me-1"></i>Go to Dashboard
                    </button>
                    <button
                      className="btn btn-outline-secondary"
                      onClick={() => {
                        this.setState({ hasError: false, error: null });
                        window.location.reload();
                      }}
                    >
                      <i className="bi bi-arrow-clockwise me-1"></i>Refresh Page
                    </button>
                  </div>
                  {process.env.NODE_ENV !== 'production' && this.state.error && (
                    <details className="mt-4 text-start">
                      <summary className="text-muted small">Error details (dev only)</summary>
                      <pre className="mt-2 p-3 bg-light rounded small" style={{ maxHeight: 200, overflow: 'auto' }}>
                        {this.state.error.toString()}
                      </pre>
                    </details>
                  )}
                  <div className="mt-4 small text-muted">
                    Contact: <code>stewards@kromarketplace.com</code>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
